const downloadFile = (fileBlob, fileName) => {
  const downloadUrl = window.URL.createObjectURL(fileBlob);
  const link = document.createElement("a");
  link.href = downloadUrl;
  link.setAttribute("download", fileName);
  document.body.appendChild(link);
  link.click();
  link.remove();
  // Revoke the object URL after a short delay to allow download to start
  setTimeout(() => {
    window.URL.revokeObjectURL(downloadUrl);
  }, 100);
};

const FileDownloadService = {
  downloadFile,
};

export default FileDownloadService;
